import angular from 'angular'

const MODALS_CONTAINER_CLASS = 'vd-modals-container'
const MODALS_CONTAINER_TEMPLATE = `<div class="${MODALS_CONTAINER_CLASS}"></div>`

/**
 * Provides a singleton container to insert any modal-like element into (e.g. a dialog, overlay, splash, etc). The
 * container itself has explicit positioning and a set z-index allowing the inserted elements to rely on DOM order
 * to determine how they stack (while stacking above all other elements due to the inherited z-index).
 *
 * @module vend.ui.vdModalsContainerService
 */
angular
  .module('vend.ui')
  .service('vdModalsContainerService', function ($document) {
    let modalsContainerElement

    function _createModalsContainer() {
      const element = $document[0].querySelector(`.${MODALS_CONTAINER_CLASS}`)
      if (element) {
        modalsContainerElement = angular.element(element)
      } else {
        const ngAppElements = document.querySelectorAll(
          '[ng-app], [ng-app] body'
        )
        const $ngAppElement = angular.element(
          ngAppElements[ngAppElements.length - 1]
        )
        modalsContainerElement = angular.element(MODALS_CONTAINER_TEMPLATE)
        $ngAppElement.append(modalsContainerElement)
      }
    }

    /**
     * Get the modals container to insert content into.
     *
     * @method getModalsContainerElement
     *
     * @return {$element} jQuery wrapper around the modals container element
     */
    this.getModalsContainerElement = function () {
      if (!modalsContainerElement) {
        _createModalsContainer()
      }

      return modalsContainerElement
    }
  })
